import React from 'react';
import PropTypes from 'prop-types';

export default class ImageWithFallback extends React.PureComponent {
    static propTypes = {

        /** Define the URL of the image to show */
        imagePath: PropTypes.string,

        /** Define the MIME type */
        type: PropTypes.string,

        /** Define the extension of the fallback image */
        fallbackExtension: PropTypes.string,

        /** Alt text for the image */
        alt: PropTypes.string,

        /** Height of the image */
        imgHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

        /** Width of the image */
        imgWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

        /** Display smaller file size images at specific viewport breakpoints */
        altImageSizes: PropTypes.arrayOf(
                PropTypes.shape({
                    viewportMaxWidth: PropTypes.number,
                    path: PropTypes.string
                })
            )
        };

    static defaultProps = {
        imagePath: '',
        type:'image/webp',
        fallbackExtension: 'jpg',
        alt: '',
        imgHeight: 'auto',
        imgWidth: '100%',
        altImageSizes: []
    };

    render() {
        const {
            imagePath,
            type,
            fallbackExtension,
            alt,
            imgHeight,
            imgWidth,
            altImageSizes
        } = this.props;

        return (
            <picture>
            {altImageSizes && (
                altImageSizes.map((altImageSize, item) => (
                    <React.Fragment key={item}>
                        <source media={`(max-width: ${altImageSize.viewportMaxWidth}px)`} srcSet={`${altImageSize.path}.webp`} type={type} />
                        <source media={`(max-width: ${altImageSize.viewportMaxWidth}px)`} srcSet={`${altImageSize.path}.${fallbackExtension}`} type={type} />
                    </React.Fragment>
                ))
            )}

                <source srcSet={`${imagePath}.webp`} type={type} />
                <img src={`${imagePath}.${fallbackExtension}`} alt={alt} height={imgHeight} width={imgWidth} />
            </picture>
        );
    }
}
